import React, { Component } from "react";
import AuthService from "./authSerivce";

const AuthContext = React.createContext({
  signinRedirectCallback: () => ({}),
  signoutRedirectCallback: () => ({}),
  signinRedirect: () => ({}),
  generateToken: () => ({})
});

export const AuthConsumer = AuthContext.Consumer;

export class AuthProvider extends Component {
  authService;
  constructor(props) {
    super(props);
    this.authService = new AuthService();
  }
  render() {
    return (
      <AuthContext.Provider value={this.authService}>
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}
